export class ContentLoggedInMilesLabel {
  id: any;
  loggedInMilesLabel: any;
  loggedInMilesLabelBusiness: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['loggedInMilesLabel']) {
        this.loggedInMilesLabel = contentjson['loggedInMilesLabel'];
      }
      if (contentjson['loggedInMilesLabelBusiness']) {
        this.loggedInMilesLabelBusiness =
          contentjson['loggedInMilesLabelBusiness'];
      }
    }
  }
}
